<template>
  <div v-if="!caixaStore.ultimoCaixa">
    <b-button v-b-modal.modal-reabertura-caixa
              class="w-100"
              variant="success"
              size="lg">
      Reabrir caixa
    </b-button>
    <b-modal id="modal-reabertura-caixa"
             centered
             title="Fechamento de caixa">
      <div class="d-flex flex-column">
        <span>Gostaria de reabrir esse caixa?</span>
        <span><strong>Saldo total: </strong>{{ cxSaldo.pedidos.saldoTotal | moneyToString }}</span>
      </div>
      <form class="mt-3">
        <!-- Motivo -->
        <CustomInput prop-label="Motivo de reabertura"
                     prop-type="text"
                     name="motivoReabertura"
                     :required="true"
                     :form-erros="formErros"
                     @blur="setValueInput"
                     @setError="setError" />
      </form>
      <template #modal-footer="{close}">
        <b-button variant="secondary"
                  class="mr-3 pl-4 pr-4 btn-voltar"
                  @click="close()">
          Voltar
        </b-button>
        <b-button variant="primary"
                  class="mr-3 pl-4 pr-4"
                  @click="reabrirCaixa">
          Reabrir caixa
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  //Services
  import caixaService from '../caixaService'

  // Inputs
  import CustomInput from "@/components/CustomInputs/CustomInput"


  export default {
    name: "ModalReaberturaCaixa",
    components: { CustomInput },
    data () {
      return {
        valorTotalPedidos: 0,
        motivoReabertura: '',
        formErros: [],
      }
    },
    computed: {
      caixaStore () {
        return this.$store.state.frenteCaixa.caixa
      },
      cxSaldo () {
        return this.$store.state.frenteCaixa.saldo
      },
      cxData () {
        return this.$store.state.frenteCaixa.cxData
      }
    },
    created () {
      this.valorTotalPedidos = this.cxSaldo.pedidos.saldoTotal
    },
    methods: {
      setValueInput (value, propriedade) {
      
        this[propriedade] = value
      },
      setError (state) {
        this.formErros = state
      },
      async reabrirCaixa () {
        if (this.formErros.length) return displayMessage('error', 'Error', 'Preencha todos os campos obrigatórios')
        try {
          loader({active: true})
          let caixaReabertura = Object.assign(this.caixaStore)
          caixaReabertura.motivoReabertura = this.motivoReabertura
          const caixa = await caixaService.reabrirCaixa(caixaReabertura)
          this.$store.dispatch('frenteCaixa/atualizarCaixa', caixa)
          displayMessage('success', 'succes', 'Caixa reaberto com sucesso')
        } catch (error) {
          const { message } = getErrors(error)
          displayMessage('error', 'Erro', message)
        } finally {
          loader({active: false})
        }
      }
    },
  }
</script>